import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Typography } from '@/components/ui/typography'
import { Focus, RotateCcw } from 'lucide-react'
import { useState } from 'react'
import ImageFocalPointPicker from './ImageFocalPointPicker'

function MediaFocalPointDialogContent({ media, onOpenChange, onApply }) {
  const [position, setPosition] = useState({
    x: Number(media.focal_point_x ?? 50),
    y: Number(media.focal_point_y ?? 50),
  })
  const imageWidth = Number(media.width ?? 0)
  const isLikelySoft = imageWidth > 0 && imageWidth < 2560

  const apply = () => {
    onApply?.({
      ...media,
      focal_point_x: position.x,
      focal_point_y: position.y,
    })
    onOpenChange(false)
  }

  return (
    <DialogContent size="xlarge" viewport="scroll">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <Focus className="size-5" /> Adjust storefront framing
        </DialogTitle>
        <DialogDescription>
          Click the most important part of the photo. We will keep that area in view when this image
          is used in wide or tall storefront sections.
        </DialogDescription>
      </DialogHeader>

      <ImageFocalPointPicker media={media} value={position} onChange={setPosition} />

      <div className="flex flex-wrap items-start justify-between gap-3">
        <Typography variant="supporting" className="max-w-xl">
          {isLikelySoft
            ? `This image is ${imageWidth}px wide and may look soft on large displays. At least 2560px is recommended; 3840px is best.`
            : 'For the sharpest large displays, use an image at least 2560px wide; 3840px is best.'}
        </Typography>
        <Button type="button" variant="ghost" onClick={() => setPosition({ x: 50, y: 50 })}>
          <RotateCcw className="size-4" /> Reset to center
        </Button>
      </div>

      <DialogFooter>
        <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
          Cancel
        </Button>
        <Button type="button" onClick={apply}>
          Apply framing
        </Button>
      </DialogFooter>
    </DialogContent>
  )
}

export default function MediaFocalPointDialog({ open, onOpenChange, media, onApply }) {
  return (
    <Dialog open={open && Boolean(media?.url)} onOpenChange={onOpenChange}>
      {open && media?.url ? (
        <MediaFocalPointDialogContent media={media} onOpenChange={onOpenChange} onApply={onApply} />
      ) : null}
    </Dialog>
  )
}
